var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSorting = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 16,
  viewBox: "0 0 9 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.69 11.516-1.18-1.242-3.01 3.168-3.01-3.168-1.18 1.242 4.19 4.41zM8.69 4.684 7.51 5.926 4.499 2.758 1.49 5.926.31 4.684 4.5.274z"
}))));
export { SvgSorting as ReactComponent };
export default __webpack_public_path__ + "assets/images/sorting.svg";